import { render } from "./trust_trustees_search.html?vue&type=template&id=272cf13e&external"
import script from "./trust_trustees_search.js?vue&type=script&lang=js&external"
export * from "./trust_trustees_search.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__